import axios from 'axios';
import moment from 'moment';

export default {
    namespaced: true,

    state: {
        withdrawableEntries: [],
        loadingWithdrawableEntries: false,
        loadingErrorWithdrawableEntries: null,

        withdrawingEntry: false,
        withdrawingError: null,
    },

    getters: {
        withdrawableEntries: (state) => state.withdrawableEntries,
        loadingWithdrawableEntries: (state) => state.loadingWithdrawableEntries,
        loadingErrorWithdrawableEntries: (state) => state.loadingErrorWithdrawableEntries,

        withdrawingEntry: (state) => state.withdrawingEntry,
        withdrawingError: (state) => state.withdrawingError,
    },

    mutations: {
        setWithdrawableEntriess(state, data) { state.withdrawableEntries = data },

        startLoadingWithdrawableEntries(state) { state.loadingWithdrawableEntries = true; },
        startWithdrawingEntry(state) { state.withdrawingEntry = true; },

        stopLoadingWithdrawableEntries(state) { state.loadingWithdrawableEntries = false; },
        stopWithdrawingEntry(state) { state.withdrawingEntry = false; },

        setLoadingErrorWithdrawableEntries(state, error) { state.loadingErrorWithdrawableEntries = error; },
        setWithdawingError(state, error) { state.withdrawingError = error; },

        clearLoadingErrorWithdrawableEntries(state) { state.loadingErrorWithdrawableEntries = null; },
        clearWithdawingError(state, error) { state.withdrawingError = null; },
    },

    actions: {
        async getWithdrawableEntries(context, options = {}) {
            context.commit('startLoadingWithdrawableEntries');
            context.commit('clearLoadingErrorWithdrawableEntries');
            try {
                var result = await axios.get(`${HOST_NAME}/api/DoublesEntry/WithdrawableEntries/${options.playerNbr}`);
                context.commit('setWithdrawableEntriess', result.data);
                context.commit('stopLoadingWithdrawableEntries');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingErrorWithdrawableEntries', error);
                context.commit('stopLoadingWithdrawableEntries');
                return Promise.reject(error);
            }
        },
        async withdrawEntry(context, data) {
            context.commit('startWithdrawingEntry');
            context.commit('clearWithdawingError');
            try {
                var result = await axios.post(`${HOST_NAME}/api/DoublesEntry/WithdrawEntry`, data);
                context.commit('stopWithdrawingEntry');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setWithdawingError', error);
                context.commit('stopWithdrawingEntry');
                return Promise.reject(error);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/doubles/withdrawable-entries.js